import { render, staticRenderFns } from "./deck-disabled-message.vue?vue&type=template&id=39a8b2b0"
import script from "./deck-disabled-message.vue?vue&type=script&lang=js"
export * from "./deck-disabled-message.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports